<template>
  <div style="background-color:#FFFFFF;">
    <div class="container ">
      <div class="pd">
        <div class="header">
          <h3 >
            What will you learn?
          </h3>
        </div>
        <div class="grid">
          <div>
            <h4 class="course-outline-h">
              <span >Course Outline</span>
            </h4>
            <div><span class="text-bold">Instructor:</span><span class="inst-name"> Upskill</span></div>
            <!-- <div style="padding-bottom: 1em;"><span class="text-bold">Lead Application Developer</span></div> -->
            <p class="course-outline">
              <span class="text-bold topics">1. Introduction to Mathematics</span>
              <ul class="list-padding list-items">
               <li>Calculus and predicate calculus</li>
                <li>Linear regression</li>
                  <li>Decision trees</li>
              </ul>
<span v-if="readMore"></span>
    <span v-else>...</span>
  </p>

  <p class="course-outline" v-show="readMore">
    <span class="text-bold topics">2. Stacking Contexts</span>


<ul class="list-padding list-items"> <li>Inductive classification
</li>
    <li> Divide and conquer paradigm</li>
    <li> Greedy method</li>
    <li> Dynamic programming	</li>
    <li> Backtracking</li>
    <li>Basic search and traversal techniques</li>
</ul>

<span class="text-bold topics">3. Measuring the Complexity of Algorithms</span>
<ul class="list-padding list-items">
  <li>Concurrency</li>
  <li>Git, merge, pull, commit, rebase</li>
  <li>Big O notation, how to check the big O notation</li>

</ul>

<span class="text-bold topics">4. Deep Learning</span>
<ul class="list-padding list-items">
  <li>Neural networks</li>
  <li>Convolutional neural networks</li>
  <li>Sequence models</li>
  <li>Hyperparameter tuning</li>

</ul>

<span class="text-bold topics">5. Data Science </span>
<ul class="list-padding list-items"><li>Probabilities, sampling techniques, confusion matrix, Bayes’ theorem</li>
  <li>Statistics, hypothesis testing
</li>
  <li>Analyzing data</li>
</ul>

<span class="text-bold topics">6. AI Infrastructure</span>
	<ul class="list-padding list-items">
    <li>Docker, containers
  </li>
   <li>Data engineering
</li>
 <li>Model deployment

</li>
  </ul>

<span class="text-bold topics">7. Business Acumen</span>
<ul class="list-padding list-items">
   <li>HBR case study and leadership articles</li>

</ul>



<span class="text-bold topics">8. Communication
</span>
<ul class="list-padding list-items">
  <li>Data privacy and ethics
</li>
  <li>Style guide
</li>
  <li>Engineering system design methodology

</li>
  <li>Presentation
</li>
</ul>

  </p>
 <a class="text-bold read-more" @click="readMore =! readMore">
    <span v-if="readMore">Read Less</span>
    <span v-else>Read More</span>
  </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
       readMore: false
    }
  }
};
</script>

<style scoped>
.text-bold{
  font-weight: 600;
}
.topics{
  font-size: 20px;
}
.list-padding{
  padding-left: 1.5em;
}
.pd{
  padding : 100px 0;
}
.list-items{
  list-style-type: circle;
}
.header h3 {
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
color: #035BF4;
}

.course-outline{
  font-size: 18px;
}
.inst-name{
  font-size: 18px;
}
.course-outline-h{
  text-transform: uppercase;
 font-family: "Open Sans";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 6.4px;
  line-height: 24px;
 color:#FFC600;
 background:#072AC8;
 max-width:630px ;
 padding: 15px 35px;
  margin: 25px 0;
}
.read-more{
color: #072ac8;
cursor: pointer;
}
@media only screen and (max-width: 600px) {
  .container{
    padding-left: 0;
    padding-right: 0;
  }
  .pd{
    padding: 50px 20px !important;
  }
}
@media only screen and (min-width: 1300px) {
  .container{
  max-width: 1350px !important;
}
.header h3{
  font-size: 24px;
}
.course-outline-h{
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
 color:white;
 background:#FF165D;
 border-radius: 6px;
 padding: 15px 25px;
  margin: 25px 0;
}
.grid li{
 font-family: "Open Sans";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304F64;
  margin: 15px 0;
}
.grid li span{
    font-family: "Open Sans";
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 24px;
  color: #304F64;
  margin: 15px 0;
}
}
.pd {
  padding: 100px 25px;
}
</style>
